import React, { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";

import styles from "./Ebox.local.scss";
import classnames from "classnames";
import _ from "i18n";
import GalleryContainer from "../Gallery/GalleryContainer";

import { getDateLabel } from "Utils";

export default class EboxComponent extends PureComponent {
  state = {
    isEbox: true,
    eboxListElement: null
  };

  componentDidMount() {
    this.setEboxListElement();
  }

  componentDidUpdate(prevProps, prevState) {
    const { mails = [] } = this.props;

    if (
      (!prevProps.mails || prevProps.mails.length === 0) &&
      mails.length > 0
    ) {
      this.setEboxListElement();
    }

    if (this.state.isEbox && !prevState.isEbox) {
      this.setEboxListElement();
    }
  }

  setEboxListElement = () => {
    setTimeout(() => {
      const eboxListElement = document.getElementById("ebox-list");
      this.setState({ eboxListElement });
    });
  };

  loadMoreMails = isVisible => {
    const { mails = [], loadMoreMails } = this.props;
    if (!isVisible || mails.length === 1) {
      return;
    }

    if (loadMoreMails) {
      loadMoreMails();
    }
  };

  displayGallery(e) {
    this.setState({ isEbox: !this.state.isEbox });
  }

  renderFetching() {
    const { fetching } = this.props;

    if (!fetching) {
      return;
    }

    return (
      <React.Fragment>
        <li className={styles.fetching} />
        <li className={styles.fetching} />
        <li className={styles.fetching} />
        <li className={styles.fetching} />
        <li className={styles.fetching} />
        <li className={styles.fetching} />
      </React.Fragment>
    );
  }

  renderHeader() {
    const { isEbox } = this.state;
    const {
      getMailsByStatus,
      getGalleryItemsByType,
      status,
      mediaType,
      hideGallery,
      hideSearch

      //medias
    } = this.props;

    //let dockTypes = [];
    return (
      <div className={classnames(styles.header, "grid-x")}>
        {isEbox ? (
          <ul className={classnames(styles.mailType, "cell small-10")}>
            <li
              className={classnames(
                styles.received,
                status === "RECEIVED" ? styles.activated : ""
              )}
              onClick={getMailsByStatus.bind(this, "RECEIVED")}
            >
              {_("Received")}
            </li>
            <li
              className={classnames(
                styles.notReaded,
                status === "UNREAD" ? styles.activated : ""
              )}
              onClick={getMailsByStatus.bind(this, "UNREAD")}
            >
              {_("Not readed")}
            </li>
            <li
              className={classnames(
                styles.error,
                status === "REFUSED" ? styles.activated : ""
              )}
              onClick={getMailsByStatus.bind(this, "REFUSED")}
            >
              {_("Error")}
            </li>
            <li
              className={classnames(
                styles.trash,
                status === "DELETED" ? styles.activated : ""
              )}
              onClick={getMailsByStatus.bind(this, "DELETED")}
            >
              {_("Trash")}
            </li>
          </ul>
        ) : hideGallery ? null : (
          <ul className={classnames(styles.mediaType, "cell small-10")}>
            <li
              className={mediaType === "ALL" ? styles.activated : ""}
              onClick={getGalleryItemsByType.bind(this, "ALL")}
            >
              {_("All")}
            </li>
            <li
              className={mediaType === "IMAGE" ? styles.activated : ""}
              onClick={getGalleryItemsByType.bind(this, "IMAGE")}
            >
              {_("IMAGE")}
            </li>
            <li
              className={mediaType === "PDF" ? styles.activated : ""}
              onClick={getGalleryItemsByType.bind(this, "PDF")}
            >
              {_("PDF")}
            </li>
            <li
              className={mediaType === "VIDEO" ? styles.activated : ""}
              onClick={getGalleryItemsByType.bind(this, "VIDEO")}
            >
              {_("VIDEO")}
            </li>
            <li
              className={mediaType === "PPT" ? styles.activated : ""}
              onClick={getGalleryItemsByType.bind(this, "PPT")}
            >
              {_("PPT")}
            </li>
          </ul>
        )}

        <div className={classnames(styles.tools, "cell small-2")}>
          {isEbox ? (
            hideSearch ? null : (
              <div className={styles.search}>
                <input type="text" />
                <i className="icon icon-magnifier" />
              </div>
            )
          ) : null}
          {hideGallery ? null : (
            <div
              className={classnames(
                styles.galery,
                !isEbox ? styles.activated : ""
              )}
              onClick={this.displayGallery.bind(this)}
            >
              <i className="icon icon-picture" />
              <span>{_("Gallery")}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderEBox() {
    const { mails = [], fetched, displayMailContent, hideGallery } = this.props;

    if (mails.length === 0 && fetched) {
      return (
        <div className={styles.notFound}>
          <img src="/img/notFound.svg" alt="Not found" />
          <span>{_("No result found")}</span>
        </div>
      );
    }

    return (
      <ul
        id="ebox-list"
        className={classnames(styles.mails, hideGallery ? styles.bigList : "")}
      >
        {mails.map(mail => {
          const { campaign, sentAt, openCount, sentStatus } = mail;
          let object = "";
          let from = "";
          let fromName = "";
          let mailDate = ["", ""];

          let classStatus = styles.mailReceived;

          if (campaign) {
            object = campaign.object;
            from = campaign.from;
            fromName = campaign.fromName;
          }
          if (sentAt && sentAt.date) {
            mailDate = getDateLabel(sentAt.date).split(", ");
          }
          if (openCount === 0) {
            classStatus = styles.mailNotReaded;
          }
          if (sentStatus === "REFUSED") {
            classStatus = styles.mailError;
          }
          return (
            <li
              key={`mail-${mail.id}`}
              onClick={displayMailContent.bind(this, mail)}
              className={classnames("grid-x", classStatus)}
            >
              <div className={classnames("cell small-4", styles.addr)}>
                <h5>{fromName}</h5>
                <span>{from}</span>
              </div>
              <p className={classnames("cell small-5", styles.subject)}>
                {object}
              </p>
              <div className={classnames("cell small-3", styles.date)}>
                <i className="icon-clock" />
                <div>
                  <p>
                    <span>{mailDate[0]}</span>
                    <span>{mailDate[1]}</span>
                  </p>
                  <i className="icon-options-vertical" />
                </div>
              </div>
            </li>
          );
        })}

        {this.renderFetching()}
        {this.renderEboxVisibilitySensore()}
      </ul>
    );
  }

  renderEboxVisibilitySensore = () => {
    const { hasMoreMails, fetching } = this.props;

    if (!this.state.eboxListElement || !hasMoreMails || fetching) {
      return;
    }

    return (
      <VisibilitySensor onChange={this.loadMoreMails}>
        {({ isVisible }) => (
          <li
            style={{ visibility: "hidden" }}
            className={classnames("grid-x", styles.mailReceived)}
          >
            <div className={classnames("cell small-4", styles.addr)}>
              <h5>Name</h5>
              <span>
                VisibilitySensor is {isVisible ? "visible" : "invisible"}
              </span>
            </div>
          </li>
        )}
      </VisibilitySensor>
    );
  };

  renderGallery() {
    const { community, mediaType } = this.props;

    return (
      <div className={styles.galleryList}>
        <GalleryContainer
          community={community}
          type={mediaType.toLowerCase()}
        />
      </div>
    );
  }

  render() {
    const { isEbox } = this.state;

    return (
      <div className={classnames(styles.ebox)}>
        <div className={classnames(styles.details)}>
          {this.renderHeader()}
          {isEbox ? this.renderEBox() : this.renderGallery()}
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/Common/Ebox/EboxComponent.js